import { h } from 'preact';
import searchIcon from "../../../assets/icons/svg/search.svg";
import style from "./style.less"

const InputSearch = ({placeholder, action}) => {
    const handleChange = (e) => {
        const value = e.target.value;
        if(action){
            action(value);
        }
    }

  return (
    <div className={style.inputSearch}>
        <input type="text" name="patientID" placeholder={placeholder} onChange={handleChange}/>
        <img src={searchIcon} alt="Search Icon" />
    </div>
  );
};

export default InputSearch;


// WEBPACK FOOTER //
// ./components/elements/InputSearch/index.js